module.exports = __webpack_public_path__ + "img/painPerceptionScale_0_w.8bd74aa7.png";